<script lang="ts">
	import BtnIcon from '$lib/buttons/v2/btnIcon.svelte';
	import Mute from '$lib/icons/mute.svelte';
	import Unmute from '$lib/icons/unmute.svelte';
	import { onMount } from 'svelte';
	import type { HTMLAttributes } from 'svelte/elements';

	interface Props extends HTMLAttributes<HTMLButtonElement> {
		videoElement: HTMLVideoElement | undefined;
	}

	let { videoElement }: Props = $props();

	let muted = $state(true);

	function toggle() {
		if (!videoElement) return;

		muted = !videoElement.muted;
		videoElement.muted = muted;
	}

	onMount(() => {
		if (!videoElement) return;

		muted = videoElement.muted;
	});
</script>

<BtnIcon
	size="small"
	theme="transparent/stone/green"
	onclick={(e) => {
		e.stopPropagation();
		toggle();
	}}
	title={muted ? 'Unmute video' : 'Mute video'}
>
	{#if muted}
		<Unmute class="w-full" />
	{:else}
		<Mute class="w-full" />
	{/if}
</BtnIcon>
